import Axios from "axios";
import { clearSession, getToken } from "./signJwtToken";

const config = require("../config/config");

// Message shown on the login page after we send someone back there
export const AUTH_MESSAGE_KEY = "authMessage";

const SESSION_ENDED_CODES = ["AUTH_REQUIRED", "TOKEN_INVALID", "ACCOUNT_INACTIVE"];

let redirecting = false;

// Send the user to the login page (once), keeping a message to show there
export const endSession = (message) => {
  clearSession();
  try {
    if (message) sessionStorage.setItem(AUTH_MESSAGE_KEY, message);
  } catch (e) {
    // ignore
  }
  if (!redirecting && window.location.pathname !== "/login") {
    redirecting = true;
    window.location.assign("/login");
  }
};

// Attach the API token to every request to our API, and end the session
// when the API says it's no longer valid.
export const installApiAuth = () => {
  Axios.interceptors.request.use((request) => {
    const token = getToken();
    if (token && String(request.url || "").startsWith(config.API_BASE)) {
      request.headers = { ...(request.headers || {}), Authorization: `Bearer ${token}` };
    }
    return request;
  });

  Axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const res = error && error.response;
      if (res && res.status === 401 && SESSION_ENDED_CODES.includes(res.data && res.data.code)) {
        endSession(res.data.message || "Your session has expired. Please sign in again.");
      }
      return Promise.reject(error);
    },
  );
};
